export const baseUrl = 'http://api.cjb.com.cn/prod-api/file/houshichang/';



// WEBPACK FOOTER //
// ./src/utils/seting.js